import React from "react";
import styled from "styled-components";
import Button from "./Button";
import { Link } from "react-router-dom";

const ErrorScreen = ({ error }) => {
  return (
    <ErrorContainer>
      <ErrorContent>
        <ErrorIcon>⚠️</ErrorIcon>
        <ErrorTitle>Oops! Something went wrong</ErrorTitle>
        <ErrorMessage>
          {error?.message ||
            "An unexpected error occurred while loading the page."}
        </ErrorMessage>
        <Link to="/">
          <Button>Return to Home</Button>
        </Link>
      </ErrorContent>
    </ErrorContainer>
  );
};

const ErrorContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: ${(props) => props.theme.colors.primary};
`;

const ErrorContent = styled.div`
  text-align: center;
  max-width: 600px;
  padding: 3rem;
  background: rgba(44, 44, 44, 0.8);
  border: 1px solid rgba(192, 160, 128, 0.2);
  border-radius: 16px;
  backdrop-filter: blur(10px);
`;

const ErrorIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 1.5rem;
`;

const ErrorTitle = styled.h1`
  font-size: 2rem;
  color: ${(props) => props.theme.colors.accent};
  margin-bottom: 1rem;
  font-family: "Cormorant Garamond", serif;
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.textSecondary};
  margin-bottom: 2rem;
  line-height: 1.6;
`;

export default ErrorScreen;
